import React, { useState } from "react";
import { Search, Filter, ChevronDown, MoreVertical } from "lucide-react";
import { Link } from "react-router-dom";
import TableComponent from "../../../shared/components/table";
import { CaseFolderColumns } from "../../../shared/components/table/columns/caseFolders";
import { SortingState } from "@tanstack/react-table";
import { ARROW_LEFT } from "../../../assets";

const ownerTabs = [
  {
    id: "individual",
    label: "Private  Individual (20)",
  },
  {
    id: "judicial",
    label: "Sort by Judicial division (30)",
  },
];

const statusTabs = [
  "All",
  "Awaiting assessment",
  "Ongoing cases",
  "Concluded cases",
];

const judicialDivisionData = [
  {
    id: "agbani",
    name: "Agbani",
    cases: [
      {
        id: "agbani-1",
        title: "Olugbenga Akintola vs Israel Anyemalu",
        appealNumber: "CV/3047/2018",
        filingDate: "31-05-2024",
        assignedCourt: "Hon. Justice Exe",
        courtNumber: "Court 3",
        status: "——",
      },
      {
        id: "agbani-2",
        title: "Olugbenga Akintola vs Israel Anyemalu",
        appealNumber: "",
        filingDate: "31-05-2024",
        assignedCourt: "Hon. Justice Exe",
        courtNumber: "Court 3",
        status: "——",
      },
    ],
  },
  {
    id: "enugu",
    name: "Enugu",
    cases: [
      {
        id: "enugu-1",
        title: "Olugbenga Akintola vs Israel Anyemalu",
        appealNumber: "",
        filingDate: "31-05-2024",
        assignedCourt: "",
        courtNumber: "",
        status: "——",
      },
    ],
  },
];

const CaseFolders = () => {
  const [activeOwnerTab, setActiveOwnerTab] = useState("individual");
  const [activeStatusTab, setActiveStatusTab] = useState("All");
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedDivisionIds, setExpandedDivisionIds] = useState<string[]>([
    "agbani",
    "enugu",
  ]);

  const toggleDivision = (id: string) => {
    setExpandedDivisionIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const mockData = [
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",

      assigned_court: "Hon. Justice Exe",
      status: "Ongoing",
      created_by: "Michael Ojo",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",

      assigned_court: "Hon. Justice Exe",
      status: "Ongoing",
      created_by: "Michael Olugbenga",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",

      assigned_court: "Hon. Justice Exe",
      status: "Ongoing",
      created_by: "Michael Bricks",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",

      assigned_court: "——",
      status: "——",
      created_by: "——",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",

      assigned_court: "——",
      status: "——",
      created_by: "——",
    },
  ];

  return (
    <div className="flex flex-col h-full min-h-screen ">
      <div className="bg-white">
        <div className="px-8 pt-6 pb-4 border-b w-full border-[#E9EAEB]">
          <h1 className="text-[28px] font-bold text-[#1A1A1A]">
            Case folder history
          </h1>
        </div>
        <div className="px-8 py-3 border-b border-[#E9EAEB] flex items-center justify-between">
          <div className="flex items-center gap-x-2 text-sm">
            <Link
              to="/admin/overview"
              className="text-[#98A2B3] hover:text-[#00B074]"
            >
              Home
            </Link>
            <img src={ARROW_LEFT} alt="" className="w-[14px] h-[14px]" />
            <span className="font-medium text-[#1A1A1A]">
              Case folder history
            </span>
          </div>
        </div>
      </div>

      {/* Top stripe / tabs */}
      <div className="bg-white border-b border-[#E9EAEB] px-8 pt-4">
        <div className="flex items-center gap-8 text-sm font-medium border-b border-[#E9EAEB]">
          {ownerTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveOwnerTab(tab.id)}
              className={`pb-3 border-b-2 ${
                activeOwnerTab === tab.id
                  ? "border-[#111827] text-[#111827]"
                  : "border-transparent text-[#667085]"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-6 mt-4 text-sm font-medium">
          {statusTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveStatusTab(tab)}
              className={`pb-3 border-b-2 ${
                activeStatusTab === tab
                  ? "border-[#111827] text-[#111827]"
                  : "border-transparent text-[#98A2B3]"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Search and table */}
      <div className="px-8 py-6 flex flex-col gap-4">
        <div className="flex items-center">
          <div className="relative w-full max-w-[320px]">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D0D5DD] focus:outline-none focus:border-[#00B074] bg-white text-sm placeholder:text-[#98A2B3]"
            />
            <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#98A2B3]" />
          </div>
        </div>
      </div>

      <div className="flex-1 px-8 pb-10">
        {activeOwnerTab === "individual" ? (
          <div className="bg-white rounded-2xl">
            <TableComponent
              DATA={mockData}
              // @ts-ignore
              COLUMNS={CaseFolderColumns}
              sorting={sorting}
              setSorting={setSorting}
            />

            <div className="flex items-center justify-between px-6 py-4 border-t border-[#E4E7EC] text-sm text-[#667085]">
              <div className="flex items-center gap-2">
                <span>
                  Page <span className="font-medium">1</span> of{" "}
                  <span className="font-medium">10</span>
                </span>
              </div>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                    Previous
                  </button>
                  <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                    Next
                  </button>
                </div>
                <div className="flex items-center gap-2">
                  <span>Entries per page:</span>
                  <select className="border border-[#D0D5DD] rounded-lg px-2 py-1 bg-white focus:outline-none text-sm">
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-2xl border border-[#E5E7EB]">
            <div className="flex items-center justify-end px-6 py-4">
              <button className="flex items-center gap-2 px-4 py-2 rounded-lg border border-[#D0D5DD] bg-white text-sm text-[#111827]">
                <Filter className="w-4 h-4 text-[#111827]" />
                <span>All cases</span>
              </button>
            </div>

            <div className="border-t border-[#E5E7EB]">
              <table className="w-full text-sm">
                <thead className="bg-[#F9FAFB] text-[#667085]">
                  <tr>
                    <th className="w-10 py-3 pl-6 text-left">SN</th>
                    <th className="py-3 text-left">Judicial Division</th>
                    <th className="py-3 text-left">Title</th>
                    <th className="py-3 text-left">Appeal number</th>
                    <th className="py-3 text-left">Filing date</th>
                    <th className="py-3 text-left">Assigned court</th>
                    <th className="py-3 text-left">Court number</th>
                    <th className="py-3 text-left">Status</th>
                    <th className="py-3 pr-6 text-left">Action</th>
                  </tr>
                </thead>
                <tbody className="text-[#111827]">
                  {judicialDivisionData.map((division) => {
                    const expanded = expandedDivisionIds.includes(division.id);

                    return (
                      <React.Fragment key={division.id}>
                        <tr className="bg-[#F9FAFB] border-b border-[#E5E7EB]">
                          <td className="py-3 pl-6">
                            <button
                              type="button"
                              onClick={() => toggleDivision(division.id)}
                              className="flex items-center"
                            >
                              <ChevronDown
                                className={`w-4 h-4 text-[#111827] transition-transform ${
                                  expanded ? "" : "-rotate-90"
                                }`}
                              />
                            </button>
                          </td>
                          <td className="py-3 font-medium">{division.name}</td>
                          <td className="py-3" colSpan={7} />
                        </tr>
                        {expanded &&
                          division.cases.map((item) => (
                            <tr
                              key={item.id}
                              className="border-b border-[#E5E7EB] hover:bg-[#F9FAFB]"
                            >
                              <td className="py-3 pl-6 align-top">
                                <input
                                  type="checkbox"
                                  className="h-4 w-4 rounded border-[#D0D5DD]"
                                />
                              </td>
                              <td className="py-3 align-top" />
                              <td className="py-3 align-top text-[#464255]">
                                {item.title}
                              </td>
                              <td className="py-3 align-top text-[#464255]">
                                {item.appealNumber || "——"}
                              </td>
                              <td className="py-3 align-top text-[#464255]">
                                {item.filingDate}
                              </td>
                              <td className="py-3 align-top text-[#464255]">
                                {item.assignedCourt || "——"}
                              </td>
                              <td className="py-3 align-top text-[#464255]">
                                {item.courtNumber || "——"}
                              </td>
                              <td className="py-3 align-top text-[#464255]">
                                {item.status || "——"}
                              </td>
                              <td className="py-3 pr-6 align-top">
                                <button className="p-1 rounded-full hover:bg-gray-100">
                                  <MoreVertical className="w-4 h-4 text-[#667085]" />
                                </button>
                              </td>
                            </tr>
                          ))}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseFolders;
